'use strict';

const urlJoin = require('url-join');
const config = require('../config');
const { default: stipulate, buildOptions, resolveUrl } = require('stipulate');

const { baseOptions } = require('./configuration');

const login = (options, query) => {
  const { baseUrl } = config.get();

  if (!options.email) {
    throw new Error('Expected `options.email` to be set');
  }

  if (!options.password) {
    throw new Error('Expected `options.password` to be set');
  }

  let url = urlJoin(baseUrl, '/pb/users/login/');
  url = resolveUrl(url, query);

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(options),
  });

  return stipulate(url, requestOptions);
};

const logout = (options, query) => {
  const { baseUrl } = config.get();

  let url = urlJoin(baseUrl, '/pb/users/logout/');
  url = resolveUrl(url, query);

  return stipulate(url, baseOptions, 'blob');
};

module.exports = {
  login,
  logout,
};
